"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Search;

var _Search = require("@adobe/react-spectrum-workflow/dist/Search");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Search(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Search.A4uSearch, null));
}